import { render, staticRenderFns } from "./SysTokenForm.vue?vue&type=template&id=4bff6d60&"
import script from "./SysTokenForm.vue?vue&type=script&lang=js&"
export * from "./SysTokenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports